import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Loading } from '@cordata/buffet';
import queryString from 'query-string';

const MedicalEventsRedirect = () => {
  const l = useLocation();
  const h = useHistory();

  useEffect(() => {
    const qp = queryString.parse(l.search);

    if (l.search && qp.type) {
      h.replace(`${l.pathname}/${qp.type}`);
    }
  }, [l.search]);

  return (
    <Loading />
  );
};

export default MedicalEventsRedirect;

